import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class AssetStorageId extends IdValueObject {
  static create(value: string): AssetStorageId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new AssetStorageId(value);
  }
}
